import { useEffect } from 'react';

import { useAuthentication } from '@givebacks/api';
import { usePlatformService } from 'core';
import { useSetAtom } from 'jotai';
import { useSearchParams } from 'react-router-dom';
import { ButtonMantine, Group } from 'ui';

import { useExperimentsContext } from '../../../provider/provider';
import { holidayDonateModalAtom, holidayExtensionModalAtom } from '../atoms';

const Actions = () => {
  const setDonateModal = useSetAtom(holidayDonateModalAtom);
  const setExtensionModal = useSetAtom(holidayExtensionModalAtom);
  const Platform = usePlatformService();

  const [searchParams] = useSearchParams();

  useEffect(() => {
    const action = searchParams.get('action');
    if (action == 'donation') {
      setDonateModal(true);
    } else if (action == 'extension') {
      setExtensionModal(true);
    }
  }, [searchParams, setDonateModal, setExtensionModal]);

  const showExtension = Platform.select({
    chrome: true,
    chromium: true,
    native: Platform.mobileBrowser == 'ios',
    mobileBrowser: Platform.mobileBrowser == 'ios',
    default: false,
  });

  const { useOpenGlobalOnboarding } = useExperimentsContext();
  const ctx = useOpenGlobalOnboarding?.();
  const { isAuthenticated } = useAuthentication();

  const getExtension = Platform.select({
    default: () =>
      isAuthenticated ? setExtensionModal(true) : ctx?.openLogin('/x/gift?action=extension'),
    mobileBrowser: () => setExtensionModal(true),
  });

  return (
    <Group grow gap={'sm'}>
      <ButtonMantine onClick={() => setDonateModal(true)}>Donate</ButtonMantine>
      {showExtension && <ButtonMantine onClick={() => getExtension()}>Get Extension</ButtonMantine>}
    </Group>
  );
};

export { Actions };
